import * as React from 'react';
import { FC, ReactNode } from 'react';
import { Header } from './Header';

type Props = {
  children: ReactNode;
};

/**
 * A React component that wraps its children with a header.
 * @param props - The props for the WithHeader component.
 * @returns A section element containing the Header and children components.
 */
export const WithHeader: FC<Props> = ({ children }: Props) => (
  <section className="App-content">
    <Header />
    {children}
  </section>
);
